<div class="report row">
  <div class="field col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-6 col-md-5 d-flex justify-content-start">
        <span class="">Client ID:</span>
      </div>
      <div class="col-6 col-md-7 d-flex justify-content-start font-weight-bold mx-0 px-0">
        <span class="itemCreated">
          {{ itm.customerId }}
        </span>
      </div>
    </div>
  </div>
  <div class="field-1 col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-3 d-flex justify-content-start">
        <span class="">Client:</span>
      </div>
      <div class="col-9 d-flex justify-content-start font-weight-bold mx-0 px-0">
        <span class="itemCreated">
          {{ itm.customerName }}
        </span>
      </div>
    </div>
  </div>
  <div class="field-2 col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-6 col-md-5 d-flex justify-content-start">
        <span class="">Phone No.:</span>
      </div>
      <div class="col-6 col-md-7 d-flex justify-content-start font-weight-bold mx-0 px-0">
        <span class="itemCreated">
          {{ itm.customerPhone1 }}
        </span>
      </div>
    </div>
  </div>
  <div class="field-3 col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-5 d-flex justify-content-start">
        <span class="">Loan Type:</span>
      </div>
      <div class="col-7 d-flex justify-content-start font-weight-bold mx-0 px-0">
        <span class="itemCreated">
          {{
          itm.productCode === 100
          ? "SAVINGS"
          : itm.productCode === 200
          ? "BODA BODA FUEL LOAN"
          : itm.productCode === 300
          ? "TAXI FUEL LOAN"
          : "MICRO LOAN"
          }}
        </span>
      </div>
    </div>
  </div>
  <div class="field-4 col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-6 col-md-5 d-flex justify-content-start">
        <span class="">Date Taken: </span>
      </div>
      <div class="col-6 col-md-7 d-flex justify-content-start font-weight-bold mx-0 px-0">
        <span class="itemCreated">
          {{ itm.dateTaken }}
        </span>
      </div>
    </div>
  </div>
  <div class="field-5 col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-6 col-md-5 d-flex justify-content-start">
        <span class="">Time Taken: </span>
      </div>
      <div class="col-6 col-md-7 d-flex justify-content-start font-weight-bold mx-0 px-0">
        <span class="itemCreated">
          {{ itm.timeTaken }}
        </span>
      </div>
    </div>
  </div>
  <div class="field col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-6 col-md-5 d-flex justify-content-start">
        <span class="">Amount Taken:</span>
      </div>
      <div class="col-6 col-md-7 d-flex justify-content-start font-weight-bold mx-0 px-0">
        <span class="itemCreated">
          {{ itm.loanAmountTaken | number }}
        </span>
      </div>
    </div>
  </div>
  <div class="field-1 col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-6 col-lg-5 d-flex justify-content-start">
        <span class="">Int + Loan Taken:</span>
      </div>
      <div class="col-6 col-lg-7 d-flex justify-content-start font-weight-bold mx-0 px-0">
        <span class="itemCreated">
          {{ itm.loanInterestTaken | number }}
        </span>
      </div>
    </div>
  </div>
  <div class="field-2 col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-6 col-md-5 d-flex justify-content-start">
        <span class="">Int + Loan Paid:</span>
      </div>
      <div class="col-6 col-md-7 d-flex justify-content-start font-weight-bold mx-0 px-0">
        <span class="itemCreated">
          {{ itm.loanInterestPaid | number }}
        </span>
      </div>
    </div>
  </div>
  <div class="field-3 col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-6 col-md-5 d-flex justify-content-start">
        <span class="">Int + Loan Left:</span>
      </div>
      <div class="col-6 col-md-7 d-flex justify-content-start font-weight-bold mx-0 px-0">
        <span class="itemCreated">
          {{ itm.loanInterestRemain | number }}
        </span>
      </div>
    </div>
  </div>
  <div class="field-4 col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-6 col-md-5 d-flex justify-content-start">
        <span class="">Int. Written Off:</span>
      </div>
      <div class="col-6 col-md-7 d-flex justify-content-start font-weight-bold mx-0 px-0">
        <span class="itemCreated">
          {{ itm.loanInterestWrittenOff }}
        </span>
      </div>
    </div>
  </div>
  <div class="field-5 col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-6 col-md-5 d-flex justify-content-start">
        <span class="">Loan Aging:</span>
      </div>
      <div class="col-6 col-md-7 d-flex justify-content-start font-weight-bold mx-0 px-0">
        <span class="itemCreated"> {{ itm.loanAging }} Day(s) </span>
      </div>
    </div>
  </div>
  <div class="field col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-6 col-md-5 d-flex justify-content-start">
        <span class="">Interest Rate:</span>
      </div>
      <div class="col-6 col-md-7 d-flex justify-content-start font-weight-bold mx-0 px-0">
        <span class="itemCreated"> {{ itm.interestRateUsed }}%  {{checkArmotCycle(itm.loanAmortCycle)}} </span>
      </div>
    </div>
  </div>
  <div class="field col-12 col-md-6 col-xl-8">
    <div class="row">
      <div class="col-4 col-lg-3 col-xl-2 d-flex justify-content-start">
        <span class="">Comment:</span>
      </div>
      <div class="col-8 col-lg-9 col-xl-10 d-flex justify-content-start font-weight-bold mx-0 px-0">
        <span class="itemCreated">
          {{ itm.customerComment }}
        </span>
      </div>
    </div>
  </div>
</div>
<div class="row mt-1 mb-2" *ngIf="showActions">
  <div class="col-12">
    <span class="">Actions</span>
    <div class="row mt-2 mb-0 mt-md-0">
      <div class="col-12 d-inline-block">
        <!-- <div class="row"> -->
        <button type="button" *ngIf="itm.productCode === 400" class="btn btn-primary mx-auto mx-md-1 mt-md-1" (click)="
              emitMicroLoanID({
                type: 'amortization',
                id: itm.loanId,
                customer: {
                  customerPhotoUrl: itm.customerPhotoUrl,
                  customerId: itm.customerId,
                  customerName: itm.customerName,
                  customerPhone1: itm.customerPhone1
                }
              })
            ">
          Amortization
        </button>
        <button type="button" *ngIf="itm.productCode === 400" class="btn btn-primary mx-auto mx-md-1 mt-md-1" (click)="
              emitMicroLoanID({
                type: 'security',
                id: itm.loanId,
                customer: {
                  customerPhotoUrl: itm.customerPhotoUrl,
                  customerId: itm.customerId,
                  customerName: itm.customerName,
                  customerPhone1: itm.customerPhone1
                }
              })
            ">
          Securities
        </button>
        <button type="button" *ngIf="itm.productCode === 400" class="btn btn-primary mx-auto mx-md-1 mt-2 mt-md-1" (click)="
              emitMicroLoanID({
                type: 'Guarantors',
                id: itm.loanId,
                customer: {
                  customerPhotoUrl: itm.customerPhotoUrl,
                  customerId: itm.customerId,
                  customerName: itm.customerName,
                  customerPhone1: itm.customerPhone1
                }
              })
            ">
          Guarantors
        </button>
        <button type="button" class="btn btn-primary mx-auto mx-md-1 mt-2 mt-md-1" (click)="
                        emitMicroLoanID({
                          type: 'Statement',
                          id: itm.loanId,
                          customer: {
                            customerPhotoUrl: itm.customerPhotoUrl,
                            customerId: itm.customerId,
                            customerName: itm.customerName,
                            customerPhone1: itm.customerPhone1
                          }
                        })
                      ">
          Loan Statement
        </button>
        <!-- <button type="button" *ngIf="itm.isSingleInstalment === 1" class="btn btn-primary mx-auto" (click)="
                        emitMicroLoanID({
                          type: 'Accrued',
                          id: itm.loanId,
                          customer: {
                            customerPhotoUrl: itm.customerPhotoUrl,
                            customerId: itm.customerId,
                            customerName: itm.customerName,
                            customerPhone1: itm.customerPhone1
                          }
                        })
                      ">
          Interest Accrual
        </button> -->
        <!-- </div> -->
      </div>
    </div>
  </div>
</div>
